import { Typography } from "@mui/material";
import { TrackDetailsProps } from "../types";
import { TrackDetailsContainer, trackDetailsStyles } from "../styles";

export const TrackDetails: React.FC<TrackDetailsProps> = ({
  title,
  artist,
}) => {
  return (
    <>
      <TrackDetailsContainer>
        <Typography noWrap sx={trackDetailsStyles.title}>
          {title}
        </Typography>
        {artist!.length > 0 && (
          <Typography noWrap sx={trackDetailsStyles.artist}>
            {artist}
          </Typography>
        )}
      </TrackDetailsContainer>
    </>
  );
};
